import { FETCH_SUNPAL_CONFIG_SUCCESS } from '../actionTypes';
import { actions } from '../reducer';

export default (data) => (dispatch) => {
    dispatch(actions[FETCH_SUNPAL_CONFIG_SUCCESS](data));
};
